import { isPetEligibleVehicle } from '@orcar/common';
import {
  convertToKST,
  filterInsuranceAtom,
  filterOptionAtom,
  getSureUserId,
  useGetVehicleModels,
  useRecoil,
} from '@orcar/common-d2c';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { isPetWhitelistedVehicleId } from '@/constants/pet-policy';
import { useGetSearchOptionFromUrl } from '@/hooks/useGetSearchOptionFromUrl';
import { trackPageView } from '@/utils/analytics';
import {
  filterVehiclesByName,
  getFilteredSearchResult,
} from '@/utils/vehicle-model';
import SearchFilters from './asideFilter/SearchFilters';
import OptionSearch from './OptionSearch';
import SearchLoading from './SearchLoading';
import SearchResult from './SearchResult';
import * as S from './styles';
import TimeoutModal from './TimeoutModal';
import { TopButton } from './TopButton';
// import FutureReservationNull from './vehicleCard/FutureReservationNull';
import SearchNull from './vehicleCard/SearchNull';

const SearchLayout = () => {
  const sureUserId = getSureUserId();

  const [searchParams] = useSearchParams();
  const isWithPet = searchParams.get('isWithPet') === 'true';

  const { initialSearchOptions } = useGetSearchOptionFromUrl();

  const { recoilValue: recoilInsurance } = useRecoil(filterInsuranceAtom); // TODO: 보험 전역 상태값을 없애고 검색 핑터 전역 내부로 이동시키기
  const { recoilValue: recoilFilterOption } = useRecoil(filterOptionAtom);

  const [isModalOpen, setIsModalOpen] = useState(false);
  // 차량명(모델명) 검색어 — 입력 즉시 결과에 반영(즉시 필터).
  const [nameQuery, setNameQuery] = useState('');
  // const [isFutureReservation, setIsFutureReservation] = useState(false);

  const {
    data: vehicleModelList,
    isLoading,
    isError,
    error,
  } = useGetVehicleModels({
    params: {
      pickUpAt: convertToKST(initialSearchOptions.pickUpAt),
      dropOffAt: convertToKST(initialSearchOptions.dropOffAt),
      driverAge: initialSearchOptions.driverAge,
      numberOfPeople: initialSearchOptions.numberOfPeople,
      drivingExperience: initialSearchOptions.drivingExperience,
      sureUserId: sureUserId ? Number(sureUserId) : undefined,
      isWithPet: isWithPet || undefined,
    },
  });

  // 펫 모드("펫과 함께")는 차종/연료 등 일반 필터와 상호배타적인 "별도 뷰"다.
  // 펫 모드에서는 차종 필터를 적용하지 않고, 펫 적격 차량만 노출한다.
  // (슈퍼카·수입차 제외 + 2020~2024년식)
  const filterResult = isWithPet
    ? vehicleModelList?.filter(
        (vehicleModel) =>
          isPetEligibleVehicle({
            type: vehicleModel.type,
            minModelYear: vehicleModel.minModelYear,
            maxModelYear: vehicleModel.maxModelYear,
          }) && isPetWhitelistedVehicleId(vehicleModel.id),
      )
    : getFilteredSearchResult(
        vehicleModelList,
        recoilFilterOption,
        recoilInsurance,
      );

  // 차량명 검색어를 결과에 즉시 적용(필터/펫 결과 위에 한 번 더 거른다).
  const searchedResult = filterVehiclesByName(filterResult, nameQuery);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 900000);

    return () => {
      clearTimeout(timer);
    };
  }, [isModalOpen]);

  // 페이지 방문 이벤트 트래킹
  useEffect(() => {
    trackPageView('search', {
      pickUpDate: initialSearchOptions.pickUpAt,
      dropOffDate: initialSearchOptions.dropOffAt,
      driverAge: initialSearchOptions.driverAge,
      numberOfPeople: initialSearchOptions.numberOfPeople,
      drivingExperience: initialSearchOptions.drivingExperience,
    });
  }, [initialSearchOptions]);

  // useEffect(() => {
  //   if (initialSearchOptions.pickUpAt) {
  //     const currentDate = new Date();
  //     const pickUpDate = new Date(initialSearchOptions.pickUpAt);

  //     const twoMonthsLater = new Date(currentDate);
  //     twoMonthsLater.setMonth(currentDate.getMonth() + 2);

  //     if (pickUpDate > twoMonthsLater) {
  //       setIsFutureReservation(true);
  //     } else {
  //       setIsFutureReservation(false);
  //     }
  //   }
  // }, [initialSearchOptions.pickUpAt]);

  return (
    <Wrapper>
      <OptionSearch searchOptions={initialSearchOptions} />
      <S.Container>
        <div className='sticky top-[200px] mr-5 flex h-fit w-[292px] flex-col'>
          <SearchFilters
            vehicleModelList={vehicleModelList}
            nameQuery={nameQuery}
            onNameQueryChange={setNameQuery}
          />
        </div>
        <S.ContentWrapper>
          <S.ContentWrapper resultSection>
            {isError ? (
              <NullWrapper>
                <SearchNull error={error} />
              </NullWrapper>
            ) : isLoading ? (
              <SearchLoading />
            ) : (
              // : isFutureReservation ? (
              //   <NullWrapper>
              //     <FutureReservationNull />
              //   </NullWrapper>
              // )
              <SearchResult
                vehicleModelList={searchedResult}
                searchOptions={initialSearchOptions}
                isWithPet={isWithPet}
              />
            )}
          </S.ContentWrapper>
        </S.ContentWrapper>
      </S.Container>
      {isModalOpen && <TimeoutModal onClose={() => setIsModalOpen(false)} />}
      <TopButton />
    </Wrapper>
  );
};

export default SearchLayout;

const Wrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  gap: 20px;
  width: 1384px;
`;

const NullWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-left: 250px;
  align-items: center;
`;
